import { useMemo } from "react"
import { useQuery } from "@apollo/client"

import { COACH_TOOLS_API } from "../apolloClient"
import { RECIPROCITY_APPLICATIONS_QUERY } from "../components/queries/reciprocityApplication"
import { flags, useFeatureFlags } from "../lib/feature-flags"
import { resolveReciprocityApplication } from "../utils/reciprocityApplication"

/**
 * The reciprocity candidate's Member application, for the dashboard status
 * card. The query runs alongside the eligibility query, but resolving the state
 * needs `eligibilityPath` from `useMemberApplyPath` (the grant is consumed at
 * approval, so the path alone cannot describe every state). It fails closed: a
 * query error, the flag off, or a missing path reports null.
 */
export function useReciprocityApplication({ eligibilityPath, skip = false }) {
  const [applicationsMembershipEnabled] =
    useFeatureFlags([flags.FLAG_FEAT_APPLICATIONS_MEMBERSHIP]) ?? []
  const skipQuery = skip || applicationsMembershipEnabled !== true

  const { data, loading } = useQuery(RECIPROCITY_APPLICATIONS_QUERY, {
    context: { api: COACH_TOOLS_API },
    fetchPolicy: "network-only",
    errorPolicy: "all",
    skip: skipQuery,
  })

  const applications = data?.membershipApplications
  const reciprocityApplication = useMemo(
    () =>
      skipQuery || !eligibilityPath
        ? null
        : resolveReciprocityApplication({ eligibilityPath, applications }),
    [skipQuery, eligibilityPath, applications],
  )

  return {
    loading: skipQuery ? false : loading,
    reciprocityApplication,
  }
}
